import React from 'react';
import { getAvatarDisplayText } from './utils';
export const AvatarText = ({ text, color, className }) => {
    const style = React.useMemo(() => ({ color }), [color]);
    const displayText = React.useMemo(() => getAvatarDisplayText(text), [text]);
    return (React.createElement("div", { style: style, className: className }, displayText));
};
